import {NgModule} from '@angular/core';

import {AdherentTableComponent} from './adherent-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
  exports: [AdherentTableComponent],
  declarations: [AdherentTableComponent],
  providers: [],
})
export class AdherentTableModule {
}
